import { Injectable } from '@angular/core';
import { Person } from 'ldt-people-api';

@Injectable({
  providedIn: 'root',
})
export class PurchasedUsersService {
  // For now we store these in memory, so they're only good for the current session
  private purchasedPeople: Set<Person> = new Set();

  constructor() {}

  addPerson(person: Person): void {
    this.purchasedPeople.add(person);
  }

  getPerson(personId: string): Person | undefined {
    // Find a record in the set where person.id === personId
    const person = Array.from(this.purchasedPeople).find((p) => p.id === personId);
    return person;
  }
}
